import(/* webpackMode: "eager" */ "/vercel/path0/app/loading.tsx");
